import FieldSelector from './selector'
import FieldTextInput from './text-input'
import FieldText from './text'

export default {
  Selector: FieldSelector,
  TextInput: FieldTextInput,
  Text: FieldText,
}
